import { PageRouteBuilder } from "@common/route/page-route-builder";
import { PersonPageComponent } from "./person-page.component";

export const personPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-person-page", PersonPageComponent)
    .atUrl("/people/:personId")
    .withTitle("People Details")
    .reloadOnSearch(false)
    .build();
